export default "__VITE_ASSET__COzKo3QP__";